import React, { useState, useEffect } from 'react';
import '../style/verificacion.css';

const Codigo = ({ onClose, contactInfo, tipo }) => {
    const [code, setCode] = useState(Array(6).fill(''));
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000);
            return () => clearTimeout(countdown);
        }
    }, [timer]);

    const handleChange = (value, index) => {
        if (!isNaN(value) && value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) document.getElementById(`input-${index + 1}`).focus();
        }
    };

    const handleVerify = () => {
        const enteredCode = code.join('');
        console.log('Código ingresado:', enteredCode);

    };

    return (
        <div className="modal-overlay blur-background">
            <div className="verificacion-container">
                <button className="cerrar-modal" onClick={onClose}>×</button>
                <div className="icono-movil"></div>
                <h2>Verificar {tipo === 'email' ? 'correo' : 'teléfono'}</h2>
                <p>Hemos enviado un código de verificación de 6 dígitos a {contactInfo}</p>

                <div className="inputs-codigo">
                    {code.map((digit, i) => (
                        <input
                            key={i}
                            id={`input-${i}`}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(e.target.value, i)}
                        />
                    ))}
                </div>

                <button onClick={handleVerify} className="boton-verificar">
                    Verificar código
                </button>

                <p className="reenvio">
                    ¿No recibiste el código? {' '}
                    {timer > 0 ?
                        `Reenviar en ${timer} segundos` :
                        <span onClick={() => setTimer(60)} className="reenviar-link">
                            Reenviar código
                        </span>
                    }
                </p>
            </div>
        </div>
    );
};

export default Codigo;